import React, { useCallback, useState, useEffect, createContext, useContext } from 'react';
import moment from 'moment';
import { Container, DateSelector, Label } from './style';

export const DateContext = createContext({});

export const DateProvider = ({ children }) => {
  const storedStart = sessionStorage.getItem('dateStart');
  const storedEnd = sessionStorage.getItem('dateEnd');

  const [dateStartP, setDateStartP] = useState(
    storedStart || moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DDTHH:mm')
  );
  const [dateEndP, setDateEndP] = useState(
    storedEnd || moment().format('YYYY-MM-DDTHH:mm')
  );

  useEffect(() => {
    sessionStorage.setItem('dateStart', dateStartP);
  }, [dateStartP]);

  useEffect(() => {
    sessionStorage.setItem('dateEnd', dateEndP);
  }, [dateEndP]);

  return (
    <DateContext.Provider value={{ dateStartP, setDateStartP, dateEndP, setDateEndP }}>
      {children}
    </DateContext.Provider>
  );
};

const DateInput = ({ label, startInput = true }) => {
  const { dateStartP, setDateStartP, dateEndP, setDateEndP } = useContext(DateContext);

  const handleSetDate = useCallback(
    (date) => {
      if (startInput) {
        setDateStartP(date);
      } else {
        setDateEndP(date);
      }
    },
    [startInput, setDateStartP, setDateEndP]
  );

  return (
    <Container>
      <Label>{label}</Label>
      <DateSelector
        type="datetime-local"
        value={startInput ? dateStartP : dateEndP}
        min="2021-01-11T00:00:00"
        max="2040-01-01T00:01:00"
        onChange={(e) => handleSetDate(e.target.value)}
      />
    </Container>
  );
};

export default DateInput;
